
import React from "react";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { HomeStats } from "@/hooks/useHomeStats";

interface WorkStatsProps {
  stats: HomeStats;
}

export const WorkStats: React.FC<WorkStatsProps> = ({ stats }) => {
  return (
    <Card>
      <CardHeader>
        <h2 className="text-lg font-bold">Statistiques de travail</h2>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-gray-50 p-4 rounded-lg text-center">
            <p className="text-sm text-gray-500">Employés Actifs</p>
            <p className="text-xl font-bold">{stats.employesActifs}</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg text-center">
            <p className="text-sm text-gray-500">Chantiers</p>
            <p className="text-xl font-bold">{stats.chantiersActifs}</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg text-center">
            <p className="text-sm text-gray-500">Ponctualité</p>
            <p className="text-xl font-bold">98%</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg text-center">
            <p className="text-sm text-gray-500">Assiduité</p>
            <p className="text-xl font-bold">100%</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
